var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"q10__title",domProps:{"innerHTML":_vm._s(_vm.options.chapterTitle)}}),_c('span',{staticClass:"q10__description",domProps:{"innerHTML":_vm._s(_vm.options.chapterDescription)}})])}
var staticRenderFns = []

export { render, staticRenderFns }